module.exports = __webpack_public_path__ + "img/slide11-piece-34.dde68adf.png";